import timg1 from '../images/team/img-1.jpg'
import timg2 from '../images/team/img-2.jpg'
import timg3 from '../images/team/img-3.jpg'
import timg4 from '../images/team/img-4.jpg'


const Teams = [
    {
       id:'1',
       tImg:timg1,
       name:'Maria D’Soza',
       title:'Planner',     
    },
    {
       id:'2',
       tImg:timg2,
       name:'John Abraham',
       title:'Makeup Artist',     
    },
    {
       id:'3',
       tImg:timg3,
       name:'Elizabeth Anny',
       title:'Planner',     
    },
    {
       id:'4',
       tImg:timg4,
       name:'Robert Willy',
       title:'Photographer',     
    }
    
]

export default Teams;